export default __webpack_public_path__ + "static/media/download.6a871355.svg";